import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    payouts: [],
    payout: {},
  },
  getters: {
    payouts: state => state.payouts,
  },
  mutations: {
    SET_PAYOUTS: (state, payouts) => { state.payouts = payouts },
    SET_PAYOUT: (state, payout) => { state.payout = payout },

  },
  actions: {
    async fetchPayouts({ commit }, queryParams) {
      const response = (await axiosIns.get('/payouts', { params: queryParams, timeout: 3000 })).data.data
      commit('SET_PAYOUTS', response)
      return response
    },

    async fetchPayout({ commit }, payoutId) {
      const response = (await axiosIns.get(`/payouts/${payoutId}`, { timeout: 3000 })).data.data
      commit('SET_DRIVER', response)
      return response
    },

    async payoutTransition(ctx, { payoutId, action }) {
      const user = JSON.parse(localStorage.getItem('userData'))
      const addedBy = user.email
      return new Promise((resolve, reject) => {
        axiosIns.post('/payouts/transition', { payoutId, action, addedBy }).then(response => {
          resolve(response.data.state)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
}
